import { DoseSliceState, localDoseSelectors } from "../../dose/doseSlice";
import GenericSelectors from "./genericSelectors";

export class CommonDoseSelectors extends GenericSelectors<DoseSliceState, typeof localDoseSelectors> {
    constructor() {
        super(localDoseSelectors);
    }
}
